import { getStudy } from "@/api/study";
import { Dispatch } from "@/reducers/app";
import { ConfigStudyAction, ReadStudyAction } from "@/reducers/study";

export async function onGetStudy(dispatch: Dispatch, id: string | null) {
  dispatch({ type: ConfigStudyAction.SetKey, id: id ?? null });

  if (!id) {
    dispatch({ type: ReadStudyAction.Error, message: "Missing id parameter" });
    return;
  }

  dispatch({ type: ReadStudyAction.Fetching });

  try {
    const study = await getStudy(id);
    dispatch({ type: ReadStudyAction.Success, study });
  } catch (e) {
    const message = e instanceof Error ? e.message : "Failed to load study";
    dispatch({ type: ReadStudyAction.Error, message });
  }
}
